import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext(null);

const translations = {
    en: {
        you: 'You',
        opponent: 'Opponent',
        yourTurn: 'Your Turn',
        waiting: 'Waiting...',
        connected: 'Connected',
        disconnected: 'Disconnected',
        tilesRemaining: 'Tiles Remaining',
        total: 'Total',
        tiles: 'tiles',
        turnHistory: 'Turn History',
        noMovesYet: 'No moves yet',
        chat: 'Chat',
        noMessagesYet: 'No messages yet',
        typeMessage: 'Type a message...',
        send: 'Send',
        turn: 'TURN',
        passed: 'Passed',
        swappedTiles: 'Swapped tiles',
        helpTitle: 'Game Rules',
        helpClose: 'Close',
        home: 'Home',
        backToLanding: 'Back to landing page',
        confirmNewGame: 'Start a new game? Current game will be lost.',
        confirmLeaveGame: 'Leave this game and return to the landing page?',
        confirmPass: 'Pass your turn?',
        yes: 'Yes',
        no: 'No',
        createGame: 'New Game With Invited Opponent',
        joinGame: 'Join Private Game',
        enterGameCode: 'Code or invite link',
        join: 'Join',
        howToPlay: 'Game Rules',
        invalidCode: 'Enter a valid code or invite link',
        leaderboard: 'Leaderboard',
        loading: 'Loading...',
        noGamesYet: 'No games yet',
        myGames: 'My Games',
        items: 'items',
        inProgress: 'In Progress',
        finished: 'Finished',
        myGamesFilterAll: 'All Games',
        myGamesSortRecent: 'Recent first',
        myGamesSortOldest: 'Oldest first',
        showFinishedGames: 'Show finished',
        hideFinishedGames: 'Hide finished',
        continueGame: 'Continue',
        viewFinalBoard: 'View Final Board',
        reviewGame: 'Review',
        gamesLoadFailed: 'Failed to load your games',
        finalBoardLoadFailed: 'Failed to load final board',
        resumeLoadFailed: 'Failed to load game resume data',
        reviewLoadFailed: 'Failed to load game review',
        gameLinkNotAccessible: 'This game link is not available for this user session.',
        roomFull: 'Room is full (max 2 players)',
        originNotAllowed: 'Connection blocked by server origin policy',
        tooManyConnections: 'Too many connections from this network',
        malformedGameLink: 'Invalid game link',
        multiplayerJoinFailed: 'Unable to join this game link',
        usernameTaken: 'Username is taken',
        usernameSuggestion: 'Try',
        usernameLabel: 'Your Username',
        authAsGuest: 'Playing as guest',
        authSignedInAs: 'Signed in',
        login: 'Login',
        signup: 'Sign up',
        logout: 'Logout',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        loginAction: 'Login to account',
        signupAction: 'Create account',
        authSessionExpired: 'Session expired. Please login again.',
        authInvalidCredentials: 'Invalid email or password',
        authSignupFailed: 'Failed to create account',
        authLoginFailed: 'Failed to login',
        authLogoutFailed: 'Failed to logout',
        authForgotPassword: 'Forgot Password',
        authResetPassword: 'Reset Password',
        authVerifyEmail: 'Verify Email',
        authTokenLabel: 'Verification/Reset token',
        authSendResetLink: 'Send reset link',
        authResetPasswordAction: 'Reset password',
        authVerifyEmailAction: 'Verify email',
        authResendVerification: 'Resend verification',
        authVerificationSent: 'Verification email sent.',
        authVerificationSentDevFallback: 'Email provider not configured. Use returned dev token preview.',
        authResetSent: 'If the email exists, reset instructions were sent.',
        authResetSentDevFallback: 'Email provider not configured. Use returned dev reset token preview.',
        authResetPasswordSuccess: 'Password reset successful. You can login now.',
        authForgotPasswordFailed: 'Failed to start password reset',
        authResetPasswordFailed: 'Failed to reset password',
        authVerifyEmailFailed: 'Failed to verify email',
        authVerifyEmailSuccess: 'Email verified successfully.',
        authVerifyingFromLink: 'Verifying email from link...',
        authResendVerificationFailed: 'Failed to resend verification',
        authAlreadyVerified: 'Email is already verified.',
        authEmailNotVerified: 'Email is not verified yet.',
        authLoginToOpenLink: 'Please login to open this protected game link.',
        authRetryingProtectedLink: 'Retrying protected game link...',
        wsAuthInvalid: 'Authentication required to join this room',
        wsAccountDisabled: 'This account is disabled',
        findingOpponent: 'Finding Opponent...',
        playRandomOpponent: 'Play Random Opponent',
        waitingForPlayer: 'Waiting for another player',
        queue: 'Queue',
        cancel: 'Cancel',
        failedToStartMatchmaking: 'Failed to start matchmaking',
        matchmakingCheckFailed: 'Matchmaking check failed',
        inviteFriend: 'Invite a Friend',
        shareCodeOrLink: 'Share either the game code or the invite link',
        gameCodeLabel: 'Game Code',
        inviteLinkLabel: 'Invite Link',
        share: 'Share',
        validating: 'Validating...',
        dictionaryLoading: 'Loading dictionary...',
        dictionaryUnavailable: 'Dictionary unavailable. Please wait and retry.',
        invalidWords: 'Invalid words',
        selectTilesToSwap: 'Select tiles to swap ({count})',
        tooltipNewGame: 'New game',
        tooltipHelp: 'Help',
        tooltipInvite: 'Invite',
        tooltipShuffle: 'Shuffle rack',
        tooltipSwap: 'Swap tiles',
        tooltipPass: 'Pass',
        tooltipReturn: 'Return tiles',
        codeCopied: 'Code copied',
        linkCopied: 'Link copied',
        gameOverTie: 'Tie Game!',
        gameOverWon: 'You Won!',
        gameOverLost: 'You Lost',
        gameOverPasses: 'Both players passed/swapped consecutively',
        gameOverTilesOut: 'Tile bag exhausted',
        gameOverNewGame: 'Start a New Game to play again',
        vs: 'vs',
        playVsComputer: 'Play vs Computer',
        computer: 'Computer',
        computerThinking: 'Thinking...',
        vsComputer: 'vs Computer',
        helpSections: [
            { title: 'Goal', body: 'Form valid Tamil words on the board to score points. The player with the highest score at the end wins.' },
            { title: 'Tiles', body: 'There are 4 tile types: Vowels (உயிர்), Consonants (மெய்), Combined letters (உயிர்மெய்), and Bonus tiles (மாயம்). Drag tiles from your rack onto the board.' },
            { title: 'Forming Words', body: 'Place tiles in a single row or column. The first word must cover one of the 5 star squares. After that, new words can either connect to existing words on the board, or cover a star square.' },
            { title: 'Combining Letters', body: 'Drag a vowel tile onto a consonant tile (or vice versa) to form a combined letter (உயிர்மெய்). Double-click a combined letter to split it back.' },
            { title: 'Bonus Tile', body: 'The bonus tile (மாயம்) can represent any letter. Double-click it to choose which letter it becomes.' },
            { title: 'Scoring', body: 'Each tile has point values. Multiplier squares on the board multiply letter or word scores. Star squares give 2x word score.' },
            { title: 'Swapping Tiles', body: 'Click the swap button, then select tiles on your rack, then click the swap button again to exchange them for new tiles from the bag.' },
            { title: 'Passing', body: 'You can pass your turn without playing. If both players pass or swap twice in a row, the game ends.' },
        ],
    },
    ta: {
        you: 'நீங்கள்',
        opponent: 'எதிரி',
        yourTurn: 'உங்கள் முறை',
        waiting: 'காத்திருக்கிறது...',
        connected: 'இணைக்கப்பட்டது',
        disconnected: 'துண்டிக்கப்பட்டது',
        tilesRemaining: 'மீதமுள்ள எழுத்துகள்',
        total: 'மொத்தம்',
        tiles: 'எழுத்துகள்',
        turnHistory: 'ஆட்ட வரலாறு',
        noMovesYet: 'இன்னும் ஆட்டம் இல்லை',
        chat: 'உரையாடல்',
        noMessagesYet: 'இன்னும் செய்திகள் இல்லை',
        typeMessage: 'செய்தி எழுதுங்கள்...',
        send: 'அனுப்பு',
        turn: 'முறை',
        passed: 'தவிர்த்தார்',
        swappedTiles: 'எழுத்துகள் மாற்றினார்',
        helpTitle: 'விளையாட்டு முறை',
        helpClose: 'மூடு',
        home: 'முகப்பு',
        backToLanding: 'முகப்பு பக்கத்துக்கு செல்',
        confirmNewGame: 'புது விளையாட்டு தொடங்கவா? நடப்பு ஆட்டம் இழக்கப்படும்.',
        confirmLeaveGame: 'இந்த ஆட்டத்தை விட்டு முகப்பு பக்கத்துக்கு திரும்பவா?',
        confirmPass: 'உங்கள் முறையைத் தவிர்க்கவா?',
        yes: 'ஆம்',
        no: 'வேண்டாம்',
        createGame: 'புது ஆட்டம் அழைப்புடன்',
        joinGame: 'இருக்கும் ஆட்டத்தில் சேர்',
        enterGameCode: 'குறியீடு / அழைப்பு இணைப்பு',
        join: 'சேர்',
        howToPlay: 'விளையாட்டு முறை',
        invalidCode: 'சரியான குறியீடு அல்லது அழைப்பு இணைப்பு உள்ளிடவும்',
        leaderboard: 'முன்னணி பட்டியல்',
        loading: 'ஏற்றுகிறது...',
        noGamesYet: 'இன்னும் தரவு இல்லை',
        myGames: 'என் ஆட்டங்கள்',
        items: 'ஆட்டங்கள்',
        inProgress: 'நடைபெறுகிறது',
        finished: 'முடிந்தது',
        myGamesFilterAll: 'அனைத்து ஆட்டங்கள்',
        myGamesSortRecent: 'புதியவை முதலில்',
        myGamesSortOldest: 'பழையவை முதலில்',
        showFinishedGames: 'முடிந்ததை காட்டு',
        hideFinishedGames: 'முடிந்ததை மறை',
        continueGame: 'தொடர்',
        viewFinalBoard: 'இறுதி பலகை பார்க்க',
        reviewGame: 'மீள்பார்',
        gamesLoadFailed: 'உங்கள் ஆட்டங்களை ஏற்ற முடியவில்லை',
        finalBoardLoadFailed: 'இறுதி பலகையை ஏற்ற முடியவில்லை',
        resumeLoadFailed: 'ஆட்ட தொடர்தரவை ஏற்ற முடியவில்லை',
        reviewLoadFailed: 'ஆட்ட மீள்பார்வையை ஏற்ற முடியவில்லை',
        gameLinkNotAccessible: 'இந்த பயனர் அமர்வில் இந்த ஆட்ட இணைப்பு கிடைக்கவில்லை.',
        roomFull: 'அறை நிரம்பியுள்ளது (அதிகபட்சம் 2 வீரர்கள்)',
        originNotAllowed: 'சேவையக மூலம் கொள்கையால் இணைப்பு தடுக்கப்பட்டது',
        tooManyConnections: 'இந்த நெட்வொர்க்கில் இருந்து மிக அதிக இணைப்புகள்',
        malformedGameLink: 'தவறான ஆட்ட இணைப்பு',
        multiplayerJoinFailed: 'இந்த ஆட்ட இணைப்பில் சேர முடியவில்லை',
        usernameTaken: 'இந்த பெயர் ஏற்கனவே பயன்படுத்தப்படுகிறது',
        usernameSuggestion: 'இதைக் முயற்சிக்கவும்',
        usernameLabel: 'உங்கள் பெயர்',
        authAsGuest: 'விருந்தினர் முறையில் விளையாடுகிறீர்கள்',
        authSignedInAs: 'உள்நுழைந்தவர்',
        login: 'உள்நுழை',
        signup: 'பதிவு செய்',
        logout: 'வெளியேறு',
        emailLabel: 'மின்னஞ்சல்',
        passwordLabel: 'கடவுச்சொல்',
        loginAction: 'கணக்கில் உள்நுழை',
        signupAction: 'கணக்கு உருவாக்கு',
        authSessionExpired: 'அமர்வு காலாவதியானது. மீண்டும் உள்நுழைக.',
        authInvalidCredentials: 'தவறான மின்னஞ்சல் அல்லது கடவுச்சொல்',
        authSignupFailed: 'கணக்கை உருவாக்க முடியவில்லை',
        authLoginFailed: 'உள்நுழைய முடியவில்லை',
        authLogoutFailed: 'வெளியேற முடியவில்லை',
        authForgotPassword: 'கடவுச்சொல் மறந்துவிட்டதா',
        authResetPassword: 'கடவுச்சொல்லை மாற்று',
        authVerifyEmail: 'மின்னஞ்சல் சரிபார்',
        authTokenLabel: 'சரிபார்ப்பு/மாற்று டோக்கன்',
        authSendResetLink: 'மாற்று இணைப்பு அனுப்பு',
        authResetPasswordAction: 'கடவுச்சொல் மாற்று',
        authVerifyEmailAction: 'மின்னஞ்சல் சரிபார்',
        authResendVerification: 'சரிபார்ப்பு மீண்டும் அனுப்பு',
        authVerificationSent: 'சரிபார்ப்பு மின்னஞ்சல் அனுப்பப்பட்டது.',
        authVerificationSentDevFallback: 'மின்னஞ்சல் வழங்குநர் அமைக்கப்படவில்லை. dev டோக்கன் முன்னோட்டத்தை பயன்படுத்தவும்.',
        authResetSent: 'இந்த மின்னஞ்சல் இருந்தால், மாற்று வழிமுறை அனுப்பப்பட்டது.',
        authResetSentDevFallback: 'மின்னஞ்சல் வழங்குநர் அமைக்கப்படவில்லை. dev reset டோக்கன் முன்னோட்டத்தை பயன்படுத்தவும்.',
        authResetPasswordSuccess: 'கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது. இப்போது உள்நுழையலாம்.',
        authForgotPasswordFailed: 'கடவுச்சொல் மாற்ற செயல்முறை தொடங்க முடியவில்லை',
        authResetPasswordFailed: 'கடவுச்சொல்லை மாற்ற முடியவில்லை',
        authVerifyEmailFailed: 'மின்னஞ்சலை சரிபார்க்க முடியவில்லை',
        authVerifyEmailSuccess: 'மின்னஞ்சல் வெற்றிகரமாக சரிபார்க்கப்பட்டது.',
        authVerifyingFromLink: 'இணைப்பில் இருந்து மின்னஞ்சலை சரிபார்க்கிறது...',
        authResendVerificationFailed: 'சரிபார்ப்பு மின்னஞ்சலை மீண்டும் அனுப்ப முடியவில்லை',
        authAlreadyVerified: 'மின்னஞ்சல் ஏற்கனவே சரிபார்க்கப்பட்டது.',
        authEmailNotVerified: 'மின்னஞ்சல் இன்னும் சரிபார்க்கப்படவில்லை.',
        authLoginToOpenLink: 'இந்த பாதுகாக்கப்பட்ட ஆட்ட இணைப்பை திறக்க உள்நுழைக.',
        authRetryingProtectedLink: 'பாதுகாக்கப்பட்ட ஆட்ட இணைப்பை மீண்டும் முயற்சிக்கிறது...',
        wsAuthInvalid: 'இந்த அறையில் சேர அடையாளச் சான்று தேவை',
        wsAccountDisabled: 'இந்த கணக்கு முடக்கப்பட்டுள்ளது',
        findingOpponent: 'எதிரியை தேடுகிறது...',
        playRandomOpponent: 'யாவொருவருடன் விளையாடுங்கள்',
        waitingForPlayer: 'மற்ற வீரரை காத்திருக்கிறது',
        queue: 'வரிசை',
        cancel: 'ரத்து செய்',
        failedToStartMatchmaking: 'மேட்ச்மேக்கிங் தொடங்க முடியவில்லை',
        matchmakingCheckFailed: 'மேட்ச்மேக்கிங் நிலையை சரிபார்க்க முடியவில்லை',
        inviteFriend: 'நண்பரை அழைக்க',
        shareCodeOrLink: 'குறியீடு அல்லது இணைப்பை பகிரவும்',
        gameCodeLabel: 'ஆட்ட குறியீடு',
        inviteLinkLabel: 'அழைப்பு இணைப்பு',
        share: 'பகிர்',
        validating: 'சரிபார்க்கிறது...',
        dictionaryLoading: 'அகராதி ஏற்றப்படுகிறது...',
        dictionaryUnavailable: 'அகராதி கிடைக்கவில்லை. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.',
        invalidWords: 'தவறான சொற்கள்',
        selectTilesToSwap: 'எழுத்துகளைத் தேர்வு செய்யவும் ({count})',
        tooltipNewGame: 'புது விளையாட்டு',
        tooltipHelp: 'உதவி',
        tooltipInvite: 'அழைப்பு',
        tooltipShuffle: 'வரிசையை மாற்று',
        tooltipSwap: 'எழுத்துகளை மாற்று',
        tooltipPass: 'தவிர்',
        tooltipReturn: 'எழுத்துகளை மீட்டெடு',
        codeCopied: 'குறியீடு நகலெடுக்கப்பட்டது',
        linkCopied: 'இணைப்பு நகலெடுக்கப்பட்டது',
        gameOverTie: 'சமநிலை!',
        gameOverWon: 'நீங்கள் வென்றீர்கள்!',
        gameOverLost: 'நீங்கள் தோற்றீர்கள்',
        gameOverPasses: 'இரு வீரர்களும் தொடர்ச்சியாக தவிர்த்தனர்',
        gameOverTilesOut: 'எழுத்துப் பை காலியானது',
        gameOverNewGame: 'மீண்டும் விளையாட புது விளையாட்டு தொடங்கவும்',
        vs: 'எதிர்',
        playVsComputer: 'கணினியுடன் விளையாடுங்கள்',
        computer: 'கணினி',
        computerThinking: 'யோசிக்கிறது...',
        vsComputer: 'கணினி எதிரி',
        helpSections: [
            { title: 'குறிக்கோள்', body: 'பலகையில் சரியான தமிழ் சொற்களை உருவாக்கி புள்ளிகள் பெறுங்கள். அதிக புள்ளிகள் பெறுபவர் வெற்றி.' },
            { title: 'எழுத்துகள்', body: 'நான்கு வகை எழுத்துகள்: உயிர், மெய், உயிர்மெய், மாயம் (போனஸ்). எழுத்துகளை உங்கள் தட்டிலிருந்து பலகைக்கு இழுக்கவும்.' },
            { title: 'சொற்களை உருவாக்குதல்', body: 'ஒரே வரிசையில் அல்லது நெடுவரிசையில் எழுத்துகளை வையுங்கள். முதல் சொல் 5 நட்சத்திர கட்டங்களில் ஒன்றை மறைக்க வேண்டும். அதன் பிறகு, புதிய சொற்கள் ஏற்கனவே உள்ள சொற்களுடன் இணையலாம், அல்லது நட்சத்திர கட்டத்தை மறைத்து தனியாகவும் வைக்கலாம்.' },
            { title: 'எழுத்துகளை இணைத்தல்', body: 'உயிர் எழுத்தை மெய் எழுத்தின் மீது இழுத்தால் உயிர்மெய் எழுத்து உருவாகும். உயிர்மெய் எழுத்தை இரட்டை சொடுக்கினால் பிரிக்கலாம்.' },
            { title: 'மாயம் எழுத்து', body: 'மாயம் (போனஸ்) எழுத்து எந்த எழுத்தாகவும் மாறலாம். அதை இரட்டை சொடுக்கி எழுத்தை தேர்வு செய்யவும்.' },
            { title: 'புள்ளிகள்', body: 'ஒவ்வொரு எழுத்துக்கும் புள்ளி மதிப்பு உண்டு. பலகையில் உள்ள பெருக்கி கட்டங்கள் எழுத்து அல்லது சொல் புள்ளிகளை பெருக்கும். நட்சத்திர கட்டம் 2x சொல் புள்ளி தரும்.' },
            { title: 'எழுத்துகளை மாற்றுதல்', body: 'மாற்று பொத்தானை அழுத்தி, தட்டில் உள்ள எழுத்துகளைத் தேர்வு செய்து, மீண்டும் மாற்று பொத்தானை அழுத்தினால் புதிய எழுத்துகள் கிடைக்கும்.' },
            { title: 'தவிர்த்தல்', body: 'உங்கள் முறையை தவிர்க்கலாம். இரு வீரர்களும் இரண்டு முறை தொடர்ச்சியாக தவிர்த்தால் அல்லது மாற்றினால் ஆட்டம் முடியும்.' },
        ],
    },
};

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState('ta');

    const toggleLanguage = useCallback(() => {
        setLanguage(prev => prev === 'en' ? 'ta' : 'en');
    }, []);

    const t = translations[language];

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}
